import "./BulletPoint.css";
import React from "react";
import ContentItem from "shared/components/cms/ContentItem";
import classnames from "classnames";

export default ({ className, contentKey, superScript }) => (
    <li className={classnames(className, "bullet-list-item")}>
        <img className="bullet" alt="" src={require("../assets/redesign2020/products/checkmark.svg")} />
        <ContentItem tag="span" contentKey={contentKey} className={superScript || ""} />
    </li>
);